(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ib-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('ib-ux-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const assignText = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };
  const assignLabel = (element, value) => {
    if (element.getAttribute('aria-label') !== value) element.setAttribute('aria-label', value);
  };
  const fill = (template, values) => template.replace(/\[(\w+)\]/g, (_, key) => values[key] ?? '');
  const bindStickyAvailability = () => {
    const opener = document.getElementById('show-sticky-product');
    const mainButton = document.querySelector('.halo-productView-right [name="add"]');
    if (!opener || !mainButton || opener.dataset.ibStockBound) return;
    opener.dataset.ibStockBound = 'true';
    const sync = () => {
      opener.disabled = mainButton.disabled;
      opener.setAttribute('aria-disabled', String(mainButton.disabled));
      assignText(opener, mainButton.disabled ? mainButton.textContent.trim() : opener.dataset.availableLabel);
    };
    sync();
    new MutationObserver(sync).observe(mainButton, {
      attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true
    });
  };
  let filterOpener;
  let filterOpen = document.body.classList.contains('open-mobile-sidebar');
  document.addEventListener('click', event => {
    const opener = event.target.closest('button.toolbar-sidebar[data-sidebar]');
    if (opener) filterOpener = opener;
  });
  new MutationObserver(() => {
    const open = document.body.classList.contains('open-mobile-sidebar');
    document.querySelectorAll('button.toolbar-sidebar[data-sidebar]').forEach(button => {
      button.setAttribute('aria-expanded', String(open));
    });
    if (open === filterOpen) return;
    filterOpen = open;
    if (open && filterOpener) {
      requestAnimationFrame(() => document.querySelector('#halo-sidebar .halo-sidebar-close')?.focus());
    } else if (filterOpener) {
      filterOpener.focus();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  let cardPointerStart;
  document.addEventListener('pointerdown', event => {
    cardPointerStart = { x: event.clientX, y: event.clientY };
  }, { passive: true });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (cardPointerStart && Math.hypot(event.clientX - cardPointerStart.x, event.clientY - cardPointerStart.y) > 8) return;
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('.product-item .card') ||
      event.target.closest('.product')?.querySelector('.product-item .card');
    if (!card || event.target.closest('a, button, input, select, textarea, label, summary, [role="button"], [role="link"], [contenteditable], .product-swatch, .card-swatch, .card-product__group, .card-quickview, .card-compare')) return;
    const title = card.querySelector('.card-title[href]');
    if (title) window.location.assign(title.href);
  });
  // Slick carousels (vendor.js) add listbox/option/tablist roles and aria-hidden on the dot
  // list items. Those roles are invalid for this markup (PageSpeed: aria-allowed-attr,
  // aria-required-children, aria-valid-attr-value, aria-hidden-focus, aria-input-field-name,
  // presentation-role-conflict). Strip them; the dots stay plain buttons with a label.
  const fixSlick = root => {
    root.querySelectorAll('.slick-track[role="listbox"]').forEach(e => e.removeAttribute('role'));
    root.querySelectorAll('.slick-slide[role="option"]').forEach(e => e.removeAttribute('role'));
    root.querySelectorAll('.slick-dots').forEach(list => {
      if (list.getAttribute('role') === 'tablist') list.removeAttribute('role');
      list.querySelectorAll(':scope > li').forEach((item, index) => {
        ['role', 'aria-selected', 'aria-controls', 'aria-hidden'].forEach(a => item.removeAttribute(a));
        const button = item.querySelector('button');
        if (!button) return;
        button.removeAttribute('role');
        if (item.classList.contains('slick-active')) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
        assignLabel(button, `Dia ${index + 1} van ${list.children.length}`);
      });
    });
  };
  const bindSlickEvents = () => {
    if (!window.jQuery || window.__ibSlickA11y) return;
    window.__ibSlickA11y = true;
    window.jQuery(document).on('init reInit afterChange breakpoint', event => {
      if (event.target instanceof Element) fixSlick(event.target);
    });
  };
  document.addEventListener('DOMContentLoaded', bindSlickEvents);
  const update = () => {
    bindStickyAvailability();
    bindSlickEvents();
    fixSlick(document);
    document.querySelectorAll('.slick-next').forEach(e => assignLabel(e, labels.next));
    document.querySelectorAll('.slick-prev').forEach(e => assignLabel(e, labels.previous));
    document.querySelectorAll('.halo-sidebar-close, .halo-popup-close, [aria-label="Close"]').forEach(e => assignLabel(e, labels.close));
    document.querySelectorAll('[aria-label="List"]').forEach(e => assignLabel(e, labels.list));
    document.querySelectorAll('[aria-label^="Grid "]').forEach(e => {
      const match = e.getAttribute('aria-label').match(/^Grid (\d+)$/);
      if (match) assignLabel(e, fill(labels.grid, {count:match[1]}));
    });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  update();
  new MutationObserver(records => {
    if (records.some(r => r.addedNodes.length)) schedule();
  }).observe(document.body, {subtree:true, childList:true});
  document.addEventListener('shopify:section:load', schedule);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-page-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    const setupProductLayout = () => {
      const secondary = document.querySelector('[data-ib-product-secondary]');
      const recommendationSlot = document.querySelector('[data-ib-recommendations-slot]');
      const productView = document.querySelector('#MainContent .productView');
      const mainSection = productView?.closest('.shopify-section');

      if (!secondary || !recommendationSlot || !productView || !mainSection) return;

      document.querySelectorAll('details.ib-product-specs').forEach((details) => {
        details.open = true;

        if (details.dataset.alwaysOpen === 'true') return;

        details.dataset.alwaysOpen = 'true';
        details.addEventListener('toggle', () => {
          if (!details.open) details.open = true;
        });
      });

      const mediaColumn = productView.querySelector('.halo-productView-left');
      const informationColumn = productView.querySelector('.halo-productView-right');
      const recommendationSection = document.querySelector('.shopify-section[id*="product-recommendations"]');
      const reviewSection = document.querySelector(
        '.shopify-section[id$="__reviews"], .shopify-section[id$="__1707547465e743a34b"]'
      );
      const recommendationContent =
        recommendationSlot.querySelector('.halo-product-block') ||
        recommendationSection?.querySelector('.halo-product-block') ||
        recommendationSection?.firstElementChild;

      if (recommendationContent && recommendationContent.parentElement !== recommendationSlot) {
        recommendationSlot.append(recommendationContent);
      }

      if (mediaColumn && informationColumn) {
        // Placed once and the same for every screen size; the mobile order is CSS only.
        if (reviewSection) {
          reviewSection.classList.add('ib-product-review-section');
          if (reviewSection.parentElement !== mediaColumn) mediaColumn.append(reviewSection);
        }

        if (recommendationSlot.parentElement !== informationColumn) {
          informationColumn.append(recommendationSlot);
        }

        secondary.hidden = true;
        return;
      }

      secondary.append(recommendationSlot);
      mainSection.after(secondary);
      secondary.hidden = !recommendationContent;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupProductLayout, { once: true });
    } else {
      setupProductLayout();
    }

    document.addEventListener('shopify:section:load', setupProductLayout);
  })();
  } catch(e) { console.error(e); }
})();

})();
